<div class="modal-header">
	<h2 class="modal-title">
		{{ config.textsKey + '.Title' | translate: config.titleParams }}
	</h2>
</div>

<div class="modal-body">
	<div *ngIf="!tokenExpired">
		<p [innerHTML]="config.textsKey + '.Body' | translate: config.bodyParams"></p>
		<p>
			{{ 'EditionConfirm.LinkExpiring' | translate }} <strong>{{ remainingSeconds }}s</strong>
		</p>
	</div>
	<p class="text-danger" *ngIf="tokenExpired">{{ 'EditionConfirm.LinkExpired' | translate }}</p>
</div>

<div class="modal-footer">
	<button id="btn-close-modal" type="button" class="btn btn-secondary" (click)="onClose()" *ngIf="tokenExpired">
		<i class="far fa-times"></i>
		{{ config.cancelBtnText | translate }}
	</button>
	<button id="btn-confirm-modal" type="button" class="btn btn-primary" (click)="onConfirm()" *ngIf="!tokenExpired">
		<i class="far fa-check"></i>
		{{ config.confirmBtnText | translate }}
	</button>
</div>
